import { createFileRoute } from "@tanstack/react-router";
import { IndustryMarketingPage, industryMarketingHead, type IndustryFAQ } from "@/components/IndustryMarketingPage";
import { TradeLeadCalculator } from "@/components/TradeLeadCalculator";

const FAQS: IndustryFAQ[] = [
  { q: "How do restoration companies get more water damage calls in Colorado?", a: "Show up in the top three Google Maps results for emergency searches like 'water damage restoration near me', answer the phone fast, and have a mobile page with a tap-to-call button. Reviews that mention the town and job help most." },
  { q: "What does restoration marketing cost?", a: "Starter $950/mo (Local SEO + Google Maps), Growth $1,650/mo (adds AI search and social media), Expert $2,750/mo (adds ad management and reputation management). Ad spend is separate. Month-to-month." },
  { q: "Should restoration companies run ads?", a: "Usually yes for burst pipe and flooding emergencies, focused on the towns you can reach quickly. SEO and Google Maps lower your cost per call over time." },
  { q: "Do you work outside Colorado Springs?", a: "Yes. We're based in Colorado Springs and help restoration companies across the Front Range, from Pueblo to Fort Collins." },
];

export const Route = createFileRoute("/restoration-marketing-colorado")({
  head: () => industryMarketingHead("Restoration", "restoration", "restoration-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry="Restoration"
      industryLower="restoration"
      slug="restoration-marketing-colorado"
      extraSections={<TradeLeadCalculator industry="Restoration" defaultJob={5000} defaultMargin={35} />}
      subheadline="We help Colorado water, fire, and mold restoration companies win emergency calls and insurance work."
      painPoints={[
        "Burst-pipe calls go to whoever shows first on Google Maps",
        "Paying high prices per lead on shared lead sites",
        "No clear pages for water, fire, mold, and storm damage",
      ]}
      serviceDescriptions={{
        seo: "Rank for water damage, flood cleanup, mold removal, and fire restoration across Colorado towns.",
        googleMaps: "Show up in the top Google Maps results when emergencies hit.",
        webDesign: "Fast mobile sites with tap-to-call, 24/7 messaging (if you offer it), and insurance help pages.",
        ppc: "Emergency-focused ads limited to the towns you can reach quickly.",
        geoAi: "Get recommended when Coloradans ask AI tools who to call for water damage.",
        socialMedia: "Before-and-after job posts that build trust with homeowners and property managers.",
      }}
      faqs={FAQS}
      cityHubLinks={[
        { to: "/water-damage-restoration-seo-colorado", label: "Water damage restoration SEO", description: "Rank for water damage searches across Colorado." },
        { to: "/water-damage-restoration-google-maps-colorado", label: "Restoration Google Maps", description: "Win the emergency map results." },
        { to: "/water-damage-restoration-web-design-colorado", label: "Restoration websites", description: "Mobile sites built to turn emergencies into calls." },
      ]}
    />
  ),
});
